(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.benchmarking = skyward.benchmarking || {};

        const benchmarkingActionNames =
        {
            delay: "Delay",
            dismiss: "Dismiss",
        };
        Object.freeze(benchmarkingActionNames);

        function setupTakeSurveyButton()
        {
            const takeSurveyButton = $(this);

            takeSurveyButton.one("workflowEnd", function ()
            {
                const container = takeSurveyButton.closest("#moduleContent");
                showCompleteConfirmation(container);
            });
        }

        function closeClick()
        {
            const closeButton = $(this);
            const container = closeButton.closest("#moduleContent");
            const benchmarkingSurveyId = closeButton.data("benchmarkingSurveyId");

            const dismissMenuItems = [{ type: "title", text: "Dismiss Options" }];

            dismissMenuItems.push(
            {
                text: "Remind Me Later",
                icon: "Time",
                click: callPostponeControllerActionLocal(benchmarkingActionNames.delay, "We will remind you again tomorrow.")
            });

            dismissMenuItems.push(
            {
                text: "Dismiss This Survey",
                icon: "Close",
                click: callPostponeControllerActionLocal(benchmarkingActionNames.dismiss, "Survey Dismissed.")
            });

            skyward.modalLayer.showMenu(dismissMenuItems, closeButton, {});

            function callPostponeControllerActionLocal(action, message)
            {
                return function ()
                {
                    callPostponeControllerAction(action, benchmarkingSurveyId, onPostponeSuccess);
                };

                function onPostponeSuccess(data)
                {
                    if (data.success)
                    {
                        closeButton.hide();

                        const cma = skyward.contentMessageArea.getContentMessageArea(container);
                        cma.setInformationMessage(message);
                        window.setTimeout(function ()
                        {
                            cma.hideInformation(true);
                            window.setTimeout(function ()
                            {
                                movePseudoContentArea(container);
                            }, 400);
                        }, 3000);
                    }
                }
            }
        }

        function callPostponeControllerAction(action, benchmarkingSurveyId, successCallback)
        {
            return $.ajax(skyward.global.virtualDir + "SkySys/BenchmarkingSurvey/" + action,
            {
                type: "POST",
                dataType: "JSON",
                activityIndicator: { hideGlass: true },
                data: { benchmarkingSurveyId: benchmarkingSurveyId },
                success: successCallback
            });
        }

        function showCompleteConfirmation(container)
        {
            const cma = skyward.contentMessageArea.getContentMessageArea(container);
            cma.hideInformation();

            const cmaElement = cma.getContentMessageAreaElement();
            const confirmationMessageElement = cmaElement.find(".cmaConfirmationMessage");

            // TODO: [4230468] This is a hack until the functionality of the CMA is more fleshed out with PR 4230468.
            confirmationMessageElement.removeClass("cmaHidden");
            cmaElement.one("CMAConfirmationHidden", function ()
            {
                confirmationMessageElement.addClass("cmaHidden");
                movePseudoContentArea(container);
            });

            cma.showConfirmation();
        }

        // TODO: Remove pseudoContentArea-benchmarking [4254690]
        function movePseudoContentArea(container)
        {
            const pseudoContentAreaClass = "pseudoContentArea--benchmarking";
            container.find(pseudoContentAreaClass.dot()).removeClass(pseudoContentAreaClass);
        }

        const events =
        {
            "setupTakeSurveyButton": setupTakeSurveyButton,
            "closeClick": closeClick
        };

        skyward.events.registerEvents("benchmarking", events);

        skyward.benchmarking.showWorkflowSurvey = function (benchmarkingData, afterSurveyCallback)
        {
            const buttonText = $("<span>", { addClass: "anchorText textBefore svgGroup fromSVG buttonText", text: "Take Survey" });
            const arrowSvg = skyward.svg.getSvg("ArrowTriangleRight");
            arrowSvg.addClass("svgNoHover svgTextBefore buttonSvg svgGroup svgContentMessageArea");

            const buttonTextElement = $("<p>", { addClass: "button cmaMessage__button svgAnchor", id: "modalTakeSurveyButton" });
            buttonTextElement.attr("href", "javascript: void (0)");
            buttonTextElement.append(buttonText);
            buttonTextElement.append(arrowSvg);

            const button = $("<div>");
            button.css({ "padding-top": "15px", "margin-left": "-1rem" });
            button.append(buttonTextElement).click(function () { launchSurveyWorkflow(); });

            const text = benchmarkingData.MessageOverride || `How was your experience in using the "${benchmarkingData.WorkflowDescription}" workflow?`;
            const messageText = $("<p>", { text: text });

            const messageDiv = $("<div>");
            messageDiv.append(messageText);
            messageDiv.append(button);

            const contents = messageDiv;
            const closeButton = {
                text: "Dismiss Survey",
                click: function () { postponeSurveyLocal(benchmarkingActionNames.dismiss); },
                icon: "Close"
            };
            const delayButton = {
                text: "Remind Me Later",
                click: function () { postponeSurveyLocal(benchmarkingActionNames.delay); },
                icon: "Time"
            };

            const dialog = skyward.modalLayer.showDialog("Feedback Survey", contents, [delayButton, closeButton], { closeOnClick: false, closeOnEscape: false });

            function postponeSurveyLocal(action)
            {
                dialog.close();
                callPostponeControllerAction(action, benchmarkingData.BenchmarkingSurveyID, null);
                afterSurveyCallback();
            }

            function launchSurveyWorkflow()
            {
                const workflowSurveyComplete = "WorkflowCompleted.SkySys.BenchmarkingSurveyInstance.TakeSurvey";
                const workflowSurveyCancelled = "WorkflowCancelled.SkySys.BenchmarkingSurveyInstance.TakeSurvey";

                const currentUserID = benchmarkingData.CurrentUserID;
                const benchmarkingSurveyID_securityhash = benchmarkingData.BenchmarkingSurveyID_securityhash;
                const benchmarkingSurveyID = benchmarkingData.BenchmarkingSurveyID;
                const userIDOwner_securityhash = benchmarkingData.UserIDOwner_securityhash;

                const doc = $(document);
                doc.one(workflowSurveyComplete, onSurveyFinish)
                doc.one(workflowSurveyCancelled, onSurveyFinish);

                skyward.window.checkLoadContent("popup", "Workflow", "WorkflowInstance", "Create/SkySys/BenchmarkingSurveyInstance/TakeSurvey", null,
                {
                    "Workflow.BenchmarkingSurveyInstance.BenchmarkingSurveyID": benchmarkingSurveyID,
                    "Workflow.BenchmarkingSurveyInstance.UserIDOwner": currentUserID,
                    "Workflow.BenchmarkingSurveyInstance.BenchmarkingSurveyID_securityhash": benchmarkingSurveyID_securityhash,
                    "Workflow.BenchmarkingSurveyInstance.UserIDOwner_securityhash": userIDOwner_securityhash
                }, null, null, null, false, null, null, null);

                function onSurveyFinish()
                {
                    doc.off(workflowSurveyComplete);
                    doc.off(workflowSurveyCancelled);

                    afterSurveyCallback();
                }
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);